import {
  WSActions,
  WSElement,
  WSInfoBox,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { ConfirmRateCardEditModalProps } from "../../utils/types";

export const ConfirmRateCardEditModal: React.FC<
  ConfirmRateCardEditModalProps
> = ({ contractorName, onClose }) => {
  return (
    <WSElement>
      <WSText.ParagraphSm mb="L">
        Are you sure you want to save rate card changes?
      </WSText.ParagraphSm>

      <WSInfoBox title="About rate card changes" icon="alert-circle" mb="L">
        <WSText.ParagraphSm>
          Rate card changes (custom rates or reversion to standard rates) will
          apply to all future work logs for{" "}
          {contractorName || "this contractor"}'s assignment. You can view which
          rates changed in the assignment's history after saving.
        </WSText.ParagraphSm>
        <WSText.ParagraphSm weight="medium" mt="M">
          Existing work logs:
        </WSText.ParagraphSm>
        <ul>
          <li>
            <b>In-progress & Submitted</b> work logs (awaiting approval): Will
            use NEW rates after save.
          </li>
          <li>
            <b>Approved</b> work logs (already invoiced): Will NOT
            change—existing invoices remain as-is.
          </li>
        </ul>
      </WSInfoBox>

      <WSActions
        alignment="fill"
        buttons={[
          {
            kind: "Secondary",
            onClick: () => onClose(false),
            label: "Go back"
          },
          {
            kind: "Primary",
            onClick: () => onClose(true),
            label: "Save changes"
          }
        ]}
      />
    </WSElement>
  );
};
